import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
  type Firestore,
  type Timestamp,
} from 'firebase/firestore';

export const DEV_ECHO_LIMIT = 50;

export interface DevEcho {
  id: string;
  message: string;
  branchId: string | null;
  /** ISO time, or null if the document has none yet. */
  occurredAt: string | null;
}

function toIso(value: unknown): string | null {
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && value !== null && 'toDate' in value) {
    return (value as Timestamp).toDate().toISOString();
  }
  return null;
}

/**
 * The person's own echoes, newest first, at most 50.
 * Needs the composite index `devEchoes (actorUid asc, occurredAt desc)`.
 */
export function watchDevEchoes(
  db: Firestore,
  actorUid: string,
  onData: (echoes: DevEcho[]) => void,
  onError: (err: Error) => void,
): () => void {
  const q = query(
    collection(db, 'devEchoes'),
    where('actorUid', '==', actorUid),
    orderBy('occurredAt', 'desc'),
    limit(DEV_ECHO_LIMIT),
  );
  return onSnapshot(
    q,
    (snap) =>
      onData(
        snap.docs.map((d) => {
          const data = d.data();
          return {
            id: d.id,
            message: typeof data.message === 'string' ? data.message : '',
            branchId: typeof data.branchId === 'string' ? data.branchId : null,
            occurredAt: toIso(data.occurredAt),
          };
        }),
      ),
    onError,
  );
}
